/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetMktuList200ResponseData } from './GetMktuList200ResponseData'
import {
  GetMktuList200ResponseDataFromJSON,
  GetMktuList200ResponseDataFromJSONTyped,
  GetMktuList200ResponseDataToJSON,
} from './GetMktuList200ResponseData'

/**
 *
 * @export
 * @interface GetMktuList200Response
 */
export interface GetMktuList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetMktuList200Response
   */
  status: boolean
  /**
   *
   * @type {GetMktuList200ResponseData}
   * @memberof GetMktuList200Response
   */
  data: GetMktuList200ResponseData
}

/**
 * Check if a given object implements the GetMktuList200Response interface.
 */
export function instanceOfGetMktuList200Response(
  value: object
): value is GetMktuList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetMktuList200ResponseFromJSON(
  json: any
): GetMktuList200Response {
  return GetMktuList200ResponseFromJSONTyped(json, false)
}

export function GetMktuList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMktuList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetMktuList200ResponseDataFromJSON(json['data']),
  }
}

export function GetMktuList200ResponseToJSON(
  value?: GetMktuList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetMktuList200ResponseDataToJSON(value['data']),
  }
}
